import { api, withFallback } from "./api";
import { SITE_SETTINGS } from "../data/site";

/**
 * Website settings.
 *
 * The API returns the business details an administrator can edit — name,
 * contact, WhatsApp number, social links, headline figures. Navigation and
 * footer structure stay in the bundle: they mirror the router, so making them
 * editable would let someone create a menu entry pointing at a page that does
 * not exist.
 *
 * The two are merged here so callers keep using one settings object.
 */
export const siteSettingsService = {
  get: async () => {
    const remote = await withFallback(() => api.get("/site-settings"), null);

    if (!remote?.brand) return SITE_SETTINGS;

    return {
      ...SITE_SETTINGS,
      brand: { ...SITE_SETTINGS.brand, ...remote.brand },
      socialLinks: remote.socialLinks ?? [],
      defaultWhatsappMessage: remote.defaultWhatsappMessage,
    };
  },
};
